import {
  View,
  Text,
  Dimensions,
  TouchableOpacity,
  Image,
  Platform,
} from "react-native";
import React from "react";
import MyText from "../custom/MyText";
import BabyIcon from "../../assets/svg/BabyIcon";
import { danger, gray, primary, white } from "../../colors";
import StepSlide from "../animation/StepSlide";
import { useState } from "react";
import PersonIcon from "../../assets/svg/PersonIcon";
import translate from "../../functions/translate";
import MyButton from "../custom/MyButton";
import { Feather } from "@expo/vector-icons";
import { babyBoy, babyGirl } from "../../imports";
import CalendarIcon from "../../assets/svg/CalendarIcon";

import PlayIcon from "../../assets/svg/PlayIcon";
import { useNavigation } from "@react-navigation/native";
import addNewTest from "../../api/test/addNewTest";
import { useDispatch } from "react-redux";
import { refresh } from "../../redux/main/mainAction";
import { currencyFormat } from "../../functions/functions";

function NotParticipated(props) {
  const [mode, setMode] = useState(1);
  const dispatch = useDispatch();
  const buttonClicked = () => {
    if (mode === 1) {
      setMode(2);
    } else {
      addNewTest(props.childId, props.id, props.type).then(({ data }) => {
        dispatch(refresh());
      });
    }
  };
  return (
    <View
      style={{
        marginLeft: Platform.OS !== "web" ? "-8%" : 0,
        marginRight: Platform.OS === "web" ? "-8%" : 0,
      }}
    >
      <StepSlide nextStep={mode === 2}>
        <View
          style={{
            width: Dimensions.get("window").width,
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <View
            style={{
              width: "90%",
              padding: 5,
              flexDirection: "row",
            }}
          >
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View
                style={{
                  marginHorizontal: 6,
                  justifyContent: "center",
                  alignItems: "center",
                  backgroundColor: white,
                  borderRadius: 20,
                  padding: 3,
                  overflow: "hidden",
                }}
              >
                <Image
                  source={{ uri: props.image }}
                  defaultSource={
                    props.childGender === "male" ? babyBoy : babyGirl
                  }
                  style={{ width: 25, height: 25 }}
                  resizeMode="contain"
                />
              </View>

              <MyText style={{ fontSize: 13, color: gray }}>
                {translate(
                  props.childGender === "male" ? "your son" : "your daughter"
                )}
              </MyText>
              <MyText
                style={{
                  fontSize: 13,
                  color: gray,
                  marginHorizontal: 2,
                  maxWidth: 50,
                }}
              >
                {props.childName}
              </MyText>
            </View>

            <View style={{ flex: 1 }}></View>
            <View>
              <MyButton
                onPress={buttonClicked}
                textStyle={{ fontSize: 11 }}
                style={{ paddingHorizontal: 5 }}
                text={translate("start test")}
              />
            </View>
          </View>
        </View>
        <View
          style={{
            width: Dimensions.get("window").width,
            alignItems: "center",
          }}
        >
          <View
            style={{
              width: "90%",
              padding: 5,
              flexDirection: "row",
            }}
          >
            <TouchableOpacity onPress={() => setMode(1)}>
              <Feather name="x" size={24} color={danger} />
            </TouchableOpacity>

            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <View style={{ marginTop: -5 }}></View>
              <MyText style={{ marginHorizontal: 4, fontSize: 14 }}>
                {`${currencyFormat(props.price)}`}
              </MyText>
              <MyText style={{ fontSize: 11, marginHorizontal: 2 }}>
                {translate("currency")}
              </MyText>
              <MyText style={{ fontSize: 10, color: gray }}>
                {translate("cost of test")}
              </MyText>
            </View>

            <View style={{ flex: 1 }}></View>
            <View>
              <MyButton
                onPress={buttonClicked}
                textStyle={{ fontSize: 11 }}
                style={{ paddingHorizontal: 10 }}
                text={translate("pay")}
              />
            </View>
          </View>
        </View>
      </StepSlide>
    </View>
  );
}

function Participated(props) {
  const navigation = useNavigation();
  return (
    <View
      style={{
        width: "100%",
        padding: 5,
        flexDirection: "row",
      }}
    >
      <View style={{ flexDirection: "row", alignItems: "center" }}>
        <View
          style={{
            marginHorizontal: 6,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: white,
            borderRadius: 20,
            padding: 3,
            overflow: "hidden",
          }}
        >
          <Image
            source={{ uri: props.image }}
            defaultSource={props.childGender === "male" ? babyBoy : babyGirl}
            style={{ width: 25, height: 25 }}
            resizeMode="contain"
          />
        </View>

        <MyText style={{ fontSize: 13, color: gray }}></MyText>
        <MyText
          style={{
            fontSize: 13,
            color: gray,
            marginHorizontal: 2,
            maxWidth: 50,
          }}
        >
          {props.childName}
        </MyText>
      </View>

      <View style={{ flex: 1 }}></View>
      {props.done ? (
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <CalendarIcon />
          <MyText style={{ marginHorizontal: 3, color: gray }}>
            {`${props.dateEnd}`}
          </MyText>
        </View>
      ) : (
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          {/* <MyText style={{ marginHorizontal: 1, color: gray }}>3</MyText>
          <MyText style={{ marginHorizontal: 1, color: gray }}>
            {translate("test")}
          </MyText>
          <MyText style={{ marginHorizontal: 1, color: gray }}>
            {translate("from")}
          </MyText>
          <MyText style={{ marginHorizontal: 1, color: gray }}>5</MyText>
          <MyText style={{ marginHorizontal: 1, color: gray }}>
            {translate("test")}
          </MyText> */}
          {/* <MyText style={{ marginHorizontal: 1, color: gray }}>
            {translate("not completed")}
          </MyText> */}
          <MyButton
            text={translate("do test")}
            onPress={() =>
              navigation.navigate("TestDetails", {
                id: props.id,
                type: props.type,
                childName: props.childName,
                childGender: props.childGender,
                childId: props.childId,
                childImage: props.image,
              })
            }
          />
          {/* <TouchableOpacity
            style={{
              width: 30,
              height: 30,
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#eee",
              borderRadius: 15,
              marginHorizontal: 4,
            }}
          >
            <PlayIcon />
          </TouchableOpacity> */}
        </View>
      )}
    </View>
  );
}

export default function TestItem(props) {
  const { image, type, age, id, gender, dateEnd, price } = props;
  const testTitle = "";

  const navigation = useNavigation();
  return props.participated ? (
    <TouchableOpacity
      onPress={() =>
        props.participated
          ? navigation.navigate("TestDetails", {
              id: id,
              type: type,
              childName: props.name,
              childGender: props.gender,
              childId: props.childId,
              childImage: image,
            })
          : null
      }
      activeOpacity={1}
      style={{
        width: "98%",
        borderRadius: 10,
        backgroundColor: "#DEE1FF",
        padding: "2%",
        overflow: "hidden",
        minHeight: 120,
        marginVertical: 5,
      }}
    >
      <View style={{ flexDirection: "row" }}>
        <MyText style={{ fontSize: 20, marginHorizontal: 3 }}>{`${translate(
          "test"
        )} ${type}`}</MyText>
        <View style={{ flex: 1 }}></View>
        <View style={{ flexDirection: "row", alignItems: "center" }}>
          <BabyIcon />
          <MyText style={{ marginHorizontal: 2, color: gray, fontSize: 13 }}>
            {`${age}`}
          </MyText>
          <MyText style={{ fontSize: 13, color: gray }}>
            {translate("monthy")}
          </MyText>
        </View>
      </View>
      <View style={{ flex: 1 }}></View>
      {props.participated ? (
        <Participated
          id={id}
          childGender={props.gender}
          childName={props.name}
          childId={props.childId}
          done={props.done}
          type={type}
          dateEnd={dateEnd}
          image={image}
        />
      ) : (
        <></>
      )}
    </TouchableOpacity>
  ) : null;
}
